var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 17.75C3.75 17.3358 4.08579 17 4.5 17H19.5C19.9142 17 20.25 17.3358 20.25 17.75C20.25 18.1642 19.9142 18.5 19.5 18.5H4.5C4.08579 18.5 3.75 18.1642 3.75 17.75Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 11.75C3.75 11.3358 4.08579 11 4.5 11H19.5C19.9142 11 20.25 11.3358 20.25 11.75C20.25 12.1642 19.9142 12.5 19.5 12.5H4.5C4.08579 12.5 3.75 12.1642 3.75 11.75Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 5.75C3.75 5.33579 4.08579 5 4.5 5H19.5C19.9142 5 20.25 5.33579 20.25 5.75C20.25 6.16421 19.9142 6.5 19.5 6.5H4.5C4.08579 6.5 3.75 6.16421 3.75 5.75Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.aa39ad79.svg";
export { ForwardRef as ReactComponent };